import axios from 'axios';
import { ProductParams } from 'types';

export const createProduct = (brandId: number, formData: ProductParams) => {
  return axios.post(`/api/brands/${brandId}/products`, formData);
};
